import { ApiFetchError, BaseError } from '@/common/errors';
import {
  GeocodeLocalDataSource,
  GeocodeRemoteDataSource,
  GeocodingResponseModel,
  LocalGeocodingResponseFeature,
  LocalGeocodingResponseModel,
} from '@/features/hazards';
import { captureException } from '@sentry/vue';
import { Either, left, right } from 'fp-ts/lib/Either';

// TODO: make an abstract class in domain repository and implement it here
export class RemoteGeocodeRepository {
  dataSource: GeocodeRemoteDataSource;

  constructor(dataSource: GeocodeRemoteDataSource) {
    this.dataSource = dataSource;
  }

  // TODO: The response should be a bespoke entity (like GeocodingResponseEntity)
  async getForwardGeocoding(searchTerm: string): Promise<Either<BaseError, GeocodingResponseModel>> {
    try {
      const response = await this.dataSource.getForwardGeocoding(searchTerm);
      return right(response);
    } catch (e) {
      captureException(e);

      return left(new ApiFetchError('addresses'));
    }
  }

  async getReverseGeocoding(latitude: number, longitude: number): Promise<Either<BaseError, GeocodingResponseModel>> {
    try {
      const response = await this.dataSource.getReverseGeocoding(latitude, longitude);
      return right(response);
    } catch (e) {
      captureException(e);

      return left(new ApiFetchError('addresses'));
    }
  }
}

export class LocalGeocodeRepository {
  dataSource: GeocodeLocalDataSource;

  constructor(dataSource: GeocodeLocalDataSource) {
    this.dataSource = dataSource;
  }

  getForwardGeocoding(searchTerm: string): LocalGeocodingResponseModel {
    const response = this.dataSource.getForwardGeocoding(searchTerm);
    return response;
  }

  getGeocodingById(id: number): LocalGeocodingResponseFeature {
    const response = this.dataSource.getGeocodingById(id);
    return response;
  }
}
